interface InvitationApiError extends Error {
  response?: {
    data?: {
      errors?: {
        email_address?: Record<string, string>;
      };
    };
  };
}

export const getInviteUserErrorMessage = (error?: Error | null): string | undefined => {
  const invitationError = error as InvitationApiError | undefined;
  const emailErrors = invitationError?.response?.data?.errors?.email_address;

  return (emailErrors && Object.values(emailErrors)[0]) || error?.message;
};
